import { observer } from 'mobx-react-lite'
import { useCallback, useEffect, useState } from 'react'

import { settingsState } from '@/app/store'
import { PageWrapper, Anchors } from '@/shared'

import { AppLogoConfig } from './AppLogoConfig/AppLogoConfig'
import { BugReport } from './BugReport/BugReport'
import style from './Settings.module.scss'
import { SlotsModal } from './SlotsModal/SlotsModal'

export const Settings = observer(() => {
    // const settingsPageState = useAsyncState(() => settingsState)

    const [isOpenImageEditor, setIsOpenImageEditor] = useState<boolean>(false)

    const anchors = [
        { title: 'Сообщения об ошибках', id: '#bug_report' },
        { title: 'Логотип', id: '#edit_logo' }
    ]

    const getBugReportList = useCallback(() => {
        if (!settingsState.bugReportList) {
            settingsState.onGetBugReportList()
        }
    }, [])

    const removeBugReport = useCallback((id: string) => {
        settingsState.onRemoveBugReport(id)
    }, [])

    const onUploadImageCallback = useCallback((file: File) => {
        settingsState.onUploadAppLogo(file)
    }, [])

    useEffect(getBugReportList, [getBugReportList])

    return (
        <div className={style.container}>
            <PageWrapper>
                <Anchors anchors={anchors} />
                <div id='#bug_report' />
                <SlotsModal
                    searchableAgentId={settingsState.searchableAgentId}
                    userSlotsList={settingsState.userSlotsList}
                    onSetSearchableAgentId={settingsState.onSetSearchableAgentId}
                    onGetSlotsByAgentId={settingsState.onGetSlotsByAgentId}
                    onSetUserSlotsList={settingsState.onSetUserSlotsList}
                    onRefundRecord={settingsState.onRefundRecord}
                />
                <BugReport
                    bugReportList={settingsState.bugReportList}
                    onRemoveBugReport={removeBugReport}
                    onSetSearchableAgentId={settingsState.onSetSearchableAgentId}
                />
                <div id='#edit_logo' />
                <AppLogoConfig
                    isOpen={isOpenImageEditor}
                    onSetIsOpen={setIsOpenImageEditor}
                    onUploadImageCallback={onUploadImageCallback}
                />
            </PageWrapper>
        </div>
    )
})
